export const fixedPhrase = {
  networkError: 'ネットワーク接続がありません。ネットワーク環境を確認後、再度お試しください。',
  serverError: 'サーバーでエラーが発生しました。しばらく時間をおいてから再度お試しください。',
  notFoundError: '対象が見つかりません。URLが正しく入力されているか再度ご確認ください。',
  validationError: '入力した内容が不正です。もう一度入力項目をご確認ください。',
  unknownError: '不明なエラーが発生しました',
} as const;
